import React from "react";
import styled from "styled-components";

const cards = [
  {
    id: 1,
    title: "Aman Mourya",
    subtitle: "Architect",
    text: "Aman is a detail-driven Architect who loves creating innovative designs and focusing on sustainable building practices. He’s experienced in drafting and 3D modeling to design spaces that are both functional and visually appealing. Aman is all about supporting the design process to make sure projects succeed.",
    img: "/home1/assets/img/team/Picture1.jpg",
  },
  {
    id: 2,
    title: "Rohit Mallah",
    subtitle: "Site Engineer",
    text: "Rohit is a hardworking Site Engineer with a strong background in construction management and handling projects on-site. He’s got hands-on experience managing daily tasks, making sure everything runs smoothly, and working with teams to meet deadlines. Rohit’s also skilled in maintaining safety standards, estimating costs, and planning project schedules.",
    img: "/home1/assets/img/team/Picture2.jpg",
  },
  {
    id: 3,
    title: "Swapnita Gupta",
    subtitle: "Interior Designer",
    text: "Swapnita is an interior designer at BDA, bringing a thoughtful, human-centered approach to every project. With a deep passion for blending form and function, Swapnita creates spaces that feel as good as they look. Through collaboration with architects, Swapnita strives to craft environments that truly enhance the way people live and work.",
    img: "/home1/assets/img/team/Picture3.jpg",
  },
  {
    id: 4,
    title: "Santosh Sharma",
    subtitle: "Carpentry Head",
    text: "With 28 years of experience in carpentry, Santosh has built a strong reputation for skilled craftsmanship and dependable leadership. He has worked on a variety of residential and commercial projects, consistently delivering high-quality results. Passionate about his craft, Santosh takes pride in every detail, ensuring that each project is completed on time and to the highest standards.",
    img: "/home1/assets/img/team/Picture4.jpg",
  },
];

function Team() {
  return (
    <Container>
      <section className="tc-team-style1">
        <div className="container">
          <div className="mb-80 mt-5">
            <h2 className="fsz-45 text-center">Meet our top-notch experts</h2>
          </div>

          <div className="row">
            {cards.map((card) => (
              <div key={card.id} className="col-12 col-md-6 col-xl-3 mb-4">
                <div className="card shadow-sm border-0 h-100">
                  <img
                    src={card.img}
                    className="card-img-top rounded-top"
                    alt={card.title}
                  />
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title fw-bold text-center">{card.title}</h5>
                    <h6 className="card-subtitle text-muted text-center">{card.subtitle}</h6>
                    <p className="card-text text-muted mt-2">{card.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Container>
  );
}

export default Team;

const Container = styled.div`
  .card {
    transition: transform 0.2s ease-in-out;
  }
  .card:hover {
    transform: scale(1.05);
  }
  .fsz-45 {
    font-size: 2.8rem;
    font-weight: bold;
  }
  .mb-80 {
    margin-bottom: 80px;
  }
  
`;
